import {
  $BODY,
  $DOCUMENT,
  $TOPLINE,
  BODY_LOCK_CLASS,
  BORDER_BOTTOM_CLASS,
  DIRECTIONS_MENU_CLASS,
  SHOW_CLASS,
  YA_POPUP_CLASS,
} from '../lib/constants'
import { closeLocalMenu, closeModalCards, isEscPressed } from '../lib/utils'
import { isToplineScroll } from '../common/topline'

export const closeOverlay = () => {
  const $overlay = $('.js-overlay')
  const $overlay_items = $('.js-overlay-item')

  $overlay.removeClass(SHOW_CLASS).removeClass(YA_POPUP_CLASS)
  $overlay_items.removeClass(SHOW_CLASS)
  $TOPLINE.removeClass(DIRECTIONS_MENU_CLASS)
}

export function overlaysFunctions() {
  const $overlay = $('.js-overlay')
  const $overlayItems = $('.js-overlay-item')

  const $BTNS = $('.js-show-overlay-btn')
  const $FORM = $('.js-contact-form:first')
  const $INPUTS_REQUIRED = $FORM.find('.input[required]')

  const $successBlock = $('.js-send-success:first')
  const $errorBlock = $('.js-send-error:first')

  // const $successBlockSubscribe = $('.js-send-success:first')
  // const $errorBlockSubscribe = $('.js-send-error:first')

  const checkMeteorMenuStatus = () => {
    if ($overlay.hasClass(SHOW_CLASS)) {
      $BODY.addClass(BODY_LOCK_CLASS)
      $TOPLINE.addClass(BORDER_BOTTOM_CLASS)
    } else {
      isToplineScroll()
      $BODY.removeClass(BODY_LOCK_CLASS)
      $TOPLINE.removeClass(BORDER_BOTTOM_CLASS).removeClass(DIRECTIONS_MENU_CLASS)
    }
  }

  const openOverlay = () => {
    const closeOverlayByActions = () => {
      $overlay.on('click', ({ target }) => {
        if ($(target).hasClass('js-overlay')) {
          closeOverlay()

          checkMeteorMenuStatus()
        }
      })

      $DOCUMENT.on('keyup', (event) => {
        if (isEscPressed(event)) {
          closeOverlay()

          checkMeteorMenuStatus()
        }
      })
    }

    closeOverlayByActions()

    $BTNS.on('click', function (event) {
      const $btn = $(this)
      const $overlayVal = $btn.attr('data-overlay')

      closeModalCards()
      closeLocalMenu()

      $overlay.addClass(SHOW_CLASS)
      $overlayItems.removeClass(SHOW_CLASS)
      $(`[data-overlay="${$overlayVal}"]`).addClass(SHOW_CLASS)

      if ($overlayVal === 'send-msg') {
        $('.js-send-mgs-title-text').show()
        $FORM.show()
        $errorBlock.hide()
        $successBlock.hide()
        $INPUTS_REQUIRED.val('')
      }

      // if ($overlayVal === 'subscribe-success') {
      //   $errorBlockSubscribe.hide()
      //   $successBlockSubscribe.hide()
      // }

      // if ($overlayVal === 'subscribe-success') {
      //   $errorBlockSubscribe.hide()
      //   $successBlockSubscribe.hide()
      // }

      if ($overlayVal === 'd-menu') {
        $TOPLINE.addClass(DIRECTIONS_MENU_CLASS)
      }

      checkMeteorMenuStatus()
    })
  }

  openOverlay()
}
